import {Component} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {UtilsService} from '../../../services/utils.service';
import {TagService} from '../../../services/tag.service';
import {ActivatedRoute, Router} from '@angular/router';
import {debounceTime} from 'rxjs/operators';

declare var $: any;
declare var UIkit: any;

@Component({
  selector: 'app-tag-view',
  templateUrl: './tag-view.component.html',
  styleUrls: ['./tag-view.component.scss']
})
export class TagViewComponent {

  modelChanged: Subject<string> = new Subject<string>();

  public tag = {faqs: []};

  constructor(private graphqlService: TagService,
              private utilsService: UtilsService,
              private router: Router,
              private route: ActivatedRoute) {

    this.modelChanged.pipe(
      debounceTime(1500)
    ).subscribe(model => this.updateTag());

    route.params.subscribe(params => {
      if (params['id']) {
        const id = params['id'];

        this.graphqlService.read(id).subscribe(result => {
          if (result && result.data) {
            this.tag = JSON.parse(JSON.stringify(result.data['tag']));
            this.utilsService.openSnackBar('Data Loaded !!', '');
          }
        });
      }
    });
  }


  dataChanged() {
    this.modelChanged.next();
  }

  updateTag() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.tag['name']);
    if (requiredSuccess) {
      this.graphqlService.update(this.tag).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Tag Updated !!', '');
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to update Tag.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }


  deleteTag() {
    UIkit.modal($('#confirm-delete')).hide();
    $('#confirm-delete').remove();
    this.graphqlService.delete(this.tag).subscribe(({data}) => {
      this.utilsService.openSnackBar('Tag Deleted !!', '');
      this.router.navigate(['/tags']);
    }, (error) => {
      this.utilsService.openSnackBar('Unable to delete Tag.', '');
      console.log('there was an error sending the query', error);
    });
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/tags/tag-view/tag-view.component.ts